var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthTrainingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L17.4352 6.48842C18.578 4.48845 17.1339 2 14.8305 2H9.16954C6.86607 2 5.42197 4.48845 6.56481 6.48842L8 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12399 23L7.63879 23.8744C7.78724 23.9568 7.95422 24 8.12399 24V23ZM15.876 23V24C16.0458 24 16.2128 23.9568 16.3612 23.8744L15.876 23ZM5 16C5 12.134 8.13401 9 12 9V7C7.02944 7 3 11.0294 3 16H5ZM8.6092 22.1256C6.45462 20.93 5 18.6342 5 16H3C3 19.3899 4.87453 22.3405 7.63879 23.8744L8.6092 22.1256ZM15.876 22H8.12399V24H15.876V22ZM19 16C19 18.6342 17.5454 20.93 15.3908 22.1256L16.3612 23.8744C19.1255 22.3405 21 19.3899 21 16H19ZM12 9C15.866 9 19 12.134 19 16H21C21 11.0294 16.9706 7 12 7V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthTrainingInactive);
export default __webpack_public_path__ + "static/media/strength-training-inactive.5afceccc8b091cd626d36275cc353dae.svg";
export { ForwardRef as ReactComponent };